import { render } from "./CategoryBannerImage.vue?vue&type=template&id=3fa3cea8&lang=pug"
import script from "./CategoryBannerImage.vue?vue&type=script&lang=js"
export * from "./CategoryBannerImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__